'use strict'
import api from '@/api/api'
import notify from "@/utils/notify"

export default {
  async getUnits(params = {}) {
    const query = new URLSearchParams()
    if (params.page) query.set('page', params.page)
    if (params.per_page) query.set('per_page', params.per_page)
    if (params.search) query.set('search', params.search)

    const data = {
      method: 'get',
      url: `units${query.toString() ? `?${query.toString()}` : ''}`,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
  },
  async createUnit(json) {
    const data = {
      method: 'post',
      url: 'unit',
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 201) {
      notify.alert.success('Unit created successfully')
      return true;
    }
  },
  async updateUnit(json, id) {
    const data = {
      method: 'put',
      url: 'unit/' + id,
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Unit updated successfully')
      return true;
    }
  },
}
